import { motion } from "framer-motion";

const BENEFITS = [
  {
    n: "01",
    title: "O método completo",
    body: "A fórmula exata da massa densa, úmida e verdadeira. Sem glúten, sem lactose, sem açúcar — e com todo o sabor de um brownie de verdade.",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    n: "02",
    title: "Recheie como quiser",
    body: "Doce de leite, pistache, cookies & cream, beijinho de coco… a base é a mesma. Você decide o recheio e cria sua versão autoral.",
    span: "md:col-span-5",
  },
  {
    n: "03",
    title: "Lista pronta",
    body: "Ingredientes certos, nas quantidades certas. Nada de tentativa e erro.",
    span: "md:col-span-5",
  },
  {
    n: "04",
    title: "Sem culpa, com propósito",
    body: "Eritritol (IG zero), colágeno hidrolisado, cacau 100%. Doçura que te move — não que te sabota.",
    span: "md:col-span-7",
  },
  {
    n: "05",
    title: "Economia real",
    body: "Produzir em casa custa uma fração do que você paga em gastronomia fit. Com a mesma qualidade — porque é a mesma receita.",
    span: "md:col-span-12",
  },
];

const card = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.7, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function RecipeBenefits() {
  return (
    <section id="beneficios" data-testid="recipe-benefits" className="bg-white">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em]">
            <span className="inline-block w-10 h-px bg-black" />
            <span>Dentro da edição</span>
          </div>
          <h2 className="font-display mt-6 text-4xl sm:text-6xl md:text-7xl leading-[0.95] tracking-[-0.025em]">
            Você não compra<br />um brownie. Você <span className="italic">domina</span> um.
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed max-w-xl">
            Não é dieta. Não é moda. É um método testado, pensado pra quem já cansou
            de pagar caro por produto fit médio. Você aprende a fazer melhor — e no
            sabor que você escolher.
          </p>
        </motion.div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-12 gap-0 border-t border-l border-black">
          {BENEFITS.map((b, i) => (
            <motion.div
              key={b.n}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={card}
              className={`relative border-r border-b border-black p-6 md:p-10 ${b.span} min-h-[220px] md:min-h-[260px] flex flex-col justify-between`}
            >
              <span className="font-display text-xl md:text-2xl">{b.n}</span>
              <div>
                <h3 className="font-display text-2xl md:text-4xl tracking-[-0.02em] leading-[1]">{b.title}</h3>
                <p className="mt-3 text-sm md:text-base leading-relaxed max-w-md">{b.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
